/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Email_Field_PlaceholderInputs */

const en_us2_auth_email_field_placeholder = /** @type {(inputs: Auth_Email_Field_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`you@example.com`)
};

const pt_br2_auth_email_field_placeholder = /** @type {(inputs: Auth_Email_Field_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`voce@exemplo.com`)
};

const es_419_auth_email_field_placeholder = /** @type {(inputs: Auth_Email_Field_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tu@ejemplo.com`)
};

const pt_pt2_auth_email_field_placeholder = /** @type {(inputs: Auth_Email_Field_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tu@exemplo.com`)
};

const fr_fr2_auth_email_field_placeholder = /** @type {(inputs: Auth_Email_Field_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`toi@exemple.com`)
};

const de_de2_auth_email_field_placeholder = /** @type {(inputs: Auth_Email_Field_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`du@beispiel.de`)
};

const it_it2_auth_email_field_placeholder = /** @type {(inputs: Auth_Email_Field_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tu@esempio.com`)
};

/**
* | output |
* | --- |
* | "you@example.com" |
*
* @param {Auth_Email_Field_PlaceholderInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const auth_email_field_placeholder = /** @type {((inputs?: Auth_Email_Field_PlaceholderInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Email_Field_PlaceholderInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_auth_email_field_placeholder(inputs)
	if (locale === "es-419") return es_419_auth_email_field_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_auth_email_field_placeholder(inputs)
	if (locale === "fr-FR") return fr_fr2_auth_email_field_placeholder(inputs)
	if (locale === "de-DE") return de_de2_auth_email_field_placeholder(inputs)
	if (locale === "it-IT") return it_it2_auth_email_field_placeholder(inputs)
	return en_us2_auth_email_field_placeholder(inputs)
});
export { auth_email_field_placeholder as "auth.email_field_placeholder" }